// @flow

import './index.scss';
import * as React from 'react';

export type AdShareButton = {
    title: string,
    render: React.Node
};

type Props = {|
    buttons: AdShareButton[]
|};

const AdShare = ({ buttons }: Props): React.Node => (
    <div className="AdShare">
        <ul className="AdShare__buttons">
            {buttons.map(button => (
                <li key={button.title} className="AdShare__button">
                    {button.render}
                </li>
            ))}
        </ul>
    </div>
);

export default AdShare;
